import React, { useState } from "react";
import {
  InputField,
  Modal,
  TextComponent,
  TimeInput,
} from "../../../../components";
import { PiSealCheck } from "react-icons/pi";
import { IoWarningOutline } from "react-icons/io5";
import styles from "./schedule.module.css";
import addClock from "../.../../../../../assets/images/addClock.png";
import { FiClock } from "react-icons/fi";
import { MdDateRange } from "react-icons/md";
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { ScheduleMiddleware } from "../../../../Store/Middlewares/ScheduleMiddleware";
import { CusAssetsMiddleware } from "../../../../Store/Middlewares/CusAssetsMiddleware";
import DateInput from "../../../../components/DateInput/DateInput";

const ScheduleModal = ({
  scheduleModal,
  setScheduleModal,
  details,
  afterDispatch,
  from,
}) => {
  const dispatch = useDispatch();
  const [scheduleDeniedModal, setScheduleDeniedModal] = useState(false);
  const [scheduleSuccessModal, setScheduleSuccessModal] = useState(false);
  const [frequency, setFrequency] = useState("one_time");
  const [title, setTitle] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");

  const onCreateSchedule = () => {
    let userData = {
      assetId: details?.id,
      title,
      frequency,
      startTime: moment(startTime).format("HH:mm"),
      endTime: moment(endTime).format("HH:mm"),
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
    };
    if (
      !title ||
      // !frequency ||
      !startTime ||
      !endTime ||
      !startDate ||
      !endDate
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are required",
        }),
      );
    } else if (moment(startTime).isAfter(moment(endTime))) {
      dispatch(
        showAlert({
          type: "Error",
          message: "End time should be greater than Start time!",
        }),
      );
    } else {
      if (from == "customer") {
        dispatch(CusAssetsMiddleware.createUpdateSchedule(userData))
          .then(() => {
            setScheduleModal(false);
            setScheduleSuccessModal(true);
            setEndTime("");
            setStartTime("");
            setTitle("");
            setStartDate("");
            setEndDate("");
          })
          .catch(() => {
            setScheduleModal(false);
            setScheduleDeniedModal(true);
          });
      } else {
        dispatch(ScheduleMiddleware.createUpdateSchedule(userData))
          .then(() => {
            setScheduleModal(false);
            setScheduleSuccessModal(true);
            setEndTime("");
            setStartTime("");
            setTitle("");
            setStartDate("");
            setEndDate("");
            // setFrequency()
            // afterDispatch(false)
          })
          .catch(() => {
            setScheduleModal(false);
            setScheduleDeniedModal(true);
          });
      }
    }
  };
  return (
    <>
      {/* /////////////////////////Schedule Modal///////////////////////// */}

      <Modal
        open={scheduleModal}
        onCancel={() => setScheduleModal(false)}
        icon={
          <img
            src={addClock}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Scheduling"}
        width={"800px"}
        twoButton
        okBtnTitle={"Save"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setScheduleModal(false);
          // setScheduleDeniedModal(true);
        }}
        onClickOkButton={onCreateSchedule}
        btnStyle={{ width: "80%" }}
        // headingClass={styles.modalHeading}
      >
        <div className={styles.schedule_modalMain}>
          <InputField
            value={title}
            placeholder={"Title"}
            onChange={(e) => setTitle(e.target.value)}
            label={"Title"}
          />
          <div className={styles.schedule_inputBox}>
            <div className={styles.schedule_input}>
              <DateInput
                label={"Start Date"}
                // value={startTime}
                value={startDate ? moment(startDate) : null}
                onChange={(e) => setStartDate(e?.$d)}
                icon={<FiClock color="var(--secondary-color)" />}
              />
              {/* <InputField
                label={"Start Date"}
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                placeholder={"start date"}
                icon={<MdDateRange color="var(--secondary-color)" />}
              /> */}
            </div>
            <div className={styles.schedule_input}>
              <DateInput
                label={"End Date"}
                value={endDate ? moment(endDate) : null}
                onChange={(e) => setEndDate(e?.$d)}
                icon={<FiClock color="var(--secondary-color)" />}
              />
              {/* <InputField
                label={"End Date"}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                placeholder={"end date"}
                icon={<MdDateRange color="var(--secondary-color)" />}
              /> */}
            </div>
          </div>
          <div className={styles.schedule_inputBox}>
            <div className={styles.schedule_input}>
              <TimeInput
                label={"Start time"}
                // value={startTime}
                value={startTime ? moment(startTime) : null}
                onChange={(e) => setStartTime(e?.$d)}
                icon={<FiClock color="var(--secondary-color)" />}
              />
            </div>
            <div className={styles.schedule_input}>
              <TimeInput
                label={"End time"}
                value={endTime ? moment(endTime) : null}
                onChange={(e) => setEndTime(e?.$d)}
                icon={<FiClock color="var(--secondary-color)" />}
              />
            </div>
          </div>
          {/* <TextComponent
            text={"Set frequency"}
            style={{
              fontFamily: "Urbanist-semibold",
              fontSize: "var(--mobile-heading)",
            }}
          />
          <div className={styles.schedule_inputBox}>
            <TextComponent
              text={"One time"}
              className={
                frequency == "one_time"
                  ? styles.schedule_frequencyBtn
                  : styles.schedule_frequencyUnactiveBtn
              }
              onClick={() => setFrequency("one_time")}
            />
            <TextComponent
              text={"Until I turn it off "}
              className={
                frequency == "one_time"
                  ? styles.schedule_frequencyUnactiveBtn
                  : styles.schedule_frequencyBtn
              }
              onClick={() => setFrequency("until_turn_off")}
            />
          </div> */}
        </div>
      </Modal>

      {/* /////////////////////////schedule Successfully///////////////////////// */}

      <Modal
        open={scheduleSuccessModal}
        onCancel={() => setScheduleSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Scheduled Successfully"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => {
          setScheduleSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      >
        {/* <TextComponent
          text={"10:00 AM to 11:00 AM"}
          style={{ fontFamily: "Urbanist-semibold", marginBottom: "10px" }}
        /> */}
      </Modal>

      {/* /////////////////////////Unable to schedule///////////////////////// */}

      <Modal
        open={scheduleDeniedModal}
        onCancel={() => setScheduleDeniedModal(false)}
        icon={
          <IoWarningOutline
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Unable to Schedule"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setScheduleDeniedModal(false)}
      >
        <TextComponent
          text={"immobilizer is already schedule on this time"}
          style={{ fontFamily: "Urbanist-semibold", marginBottom: "10px" }}
        />
      </Modal>
    </>
  );
};

export default ScheduleModal;
